import { FC } from "react";

interface FormTrProps {
  children: React.ReactNode;
}

const FormTr: FC<FormTrProps> = ({ children }: FormTrProps) => <tr>{children}</tr>;

export default FormTr;
